import { ComponentPanel, FetchedComponentPanel } from './types';
import type { EditorPointer, EditorPointerAPI } from '@wix/editorx-core-api';
import { CompRef } from '@wix/document-services-types';
import { loadPanel } from './loadPanel';

export class PanelsStore {
  private _store = new Map<string, Map<string, ComponentPanel>>();
  private _loadPanelsCache = new Map<string, Promise<FetchedComponentPanel>>();

  constructor(private editorPointerAPI: EditorPointerAPI) {}

  private generateId(editorPointer: EditorPointer<CompRef>) {
    return this.editorPointerAPI.getEditorPointerUniqueId(
      // @ts-expect-error CompPointer is not exposed by the DS
      editorPointer.documentPointer,
      editorPointer?.innerElementPath,
    );
  }

  public async loadPanel(panelUrl: string): Promise<FetchedComponentPanel> {
    const promiseFromCache = this._loadPanelsCache.get(panelUrl);
    if (promiseFromCache) {
      return promiseFromCache;
    }

    const loadPanelPromise = loadPanel(panelUrl);
    this._loadPanelsCache.set(panelUrl, loadPanelPromise);

    loadPanelPromise.finally(() => {
      this._loadPanelsCache.delete(panelUrl);
    });

    return loadPanelPromise;
  }

  public getPanel(
    editorPointer: EditorPointer<CompRef>,
    panelType: string,
  ): ComponentPanel | null {
    const id = this.generateId(editorPointer);
    return this._store.get(id)?.get(panelType) ?? null;
  }

  public setPanel(
    editorPointer: EditorPointer<CompRef>,
    panelType: string,
    panel: ComponentPanel,
  ) {
    const id = this.generateId(editorPointer);
    if (!this._store.has(id)) {
      this._store.set(id, new Map());
    }

    this._store.get(id)?.set(panelType, panel);
  }
}
